export default "__VITE_ASSET__D2LODVld__"